theme.Blog = (function() {

  function Blog() {

    var selectDropdown = document.getElementById('article-select');

    if (!selectDropdown) {
      return;
    }

    selectDropdown.addEventListener('change', function() {
      window.location = '/blogs/journal/tagged/' + this.value;
    });
  }

  return Blog;
})();
